// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "e99863e0" + "." + "b88f762912e7544b" + ".js";
};